module.exports = "\r\n<div class=\"main\">\r\n    <div class=\"section section--main\">\r\n        <logo-header></logo-header>\r\n\r\n        <div class=\"wrapper wrapper--content\">\r\n            <router-outlet></router-outlet>\r\n        </div>\r\n\r\n        <nav class=\"wrapper wrapper--nav\">\r\n            <nav-menu></nav-menu>\r\n        </nav>\r\n    </div>\r\n\r\n    <div class=\"section section--side\">\r\n        <div class=\"\"></div>\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/templates/app.component.html
// module id = 455
// module chunks = 0